import OwnerEntities from './OwnerEntities';

export default OwnerEntities;
